// extracted by mini-css-extract-plugin
export default {"img-container":"styles_img-container__Ae4VM","image":"styles_image__WANW4","flex":"styles_flex__DgLu6","image-control-button":"styles_image-control-button__oMSLU"};